import _objectWithoutProperties from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _classCallCheck from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["onComplete", "onUpdate", "motionValue", "element"],
  _excluded2 = ["motionValue", "onUpdate", "onComplete", "element"];
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { DOMKeyframesResolver } from '../../render/dom/DOMKeyframesResolver.mjs';
import { memo } from '../../utils/memo.mjs';
import { noop } from '../../utils/noop.mjs';
import { millisecondsToSeconds, secondsToMilliseconds } from '../../utils/time-conversion.mjs';
import { BaseAnimation } from './BaseAnimation.mjs';
import { MainThreadAnimation } from './MainThreadAnimation.mjs';
import { acceleratedValues } from './utils/accelerated-values.mjs';
import { animateStyle } from './waapi/index.mjs';
import { isWaapiSupportedEasing } from './waapi/easing.mjs';
import { getFinalKeyframe } from './waapi/utils/get-final-keyframe.mjs';
var supportsWaapi = /*@__PURE__*/memo(function () {
  return Object.hasOwnProperty.call(Element.prototype, "animate");
});
/**
 * 10ms is chosen here as it strikes a balance between smooth
 * results (more than one keyframe per frame at 60fps) and
 * keyframe quantity.
 */
var sampleDelta = 10; //ms
/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */
var maxDuration = 20000;
/**
 * Check if an animation can run natively via WAAPI or requires pregenerated keyframes.
 * WAAPI doesn't support spring or function easings so we run these as JS animation before
 * handing off.
 */
function requiresPregeneratedKeyframes(options) {
  return options.type === "spring" || !isWaapiSupportedEasing(options.ease);
}
function pregenerateKeyframes(keyframes, options) {
  /**
   * Create a main-thread animation to pregenerate keyframes.
   * We sample this at regular intervals to generate keyframes that we then
   * linearly interpolate between.
   */
  var sampleAnimation = new MainThreadAnimation(_objectSpread(_objectSpread({}, options), {}, {
    keyframes: keyframes,
    repeat: 0,
    delay: 0,
    isGenerator: true
  }));
  var state = {
    done: false,
    value: keyframes[0]
  };
  var pregeneratedKeyframes = [];
  /**
   * Bail after 20 seconds of pre-generated keyframes as it's likely
   * we're heading for an infinite loop.
   */
  var t = 0;
  while (!state.done && t < maxDuration) {
    state = sampleAnimation.sample(t);
    pregeneratedKeyframes.push(state.value);
    t += sampleDelta;
  }
  return {
    times: undefined,
    keyframes: pregeneratedKeyframes,
    duration: t - sampleDelta,
    ease: "linear"
  };
}
var AcceleratedAnimation = /*#__PURE__*/function (_BaseAnimation) {
  function AcceleratedAnimation(options) {
    var _this;
    _classCallCheck(this, AcceleratedAnimation);
    _this = _callSuper(this, AcceleratedAnimation, [options]);
    var _this$options = _this.options,
      name = _this$options.name,
      motionValue = _this$options.motionValue,
      element = _this$options.element,
      keyframes = _this$options.keyframes;
    _this.resolver = new DOMKeyframesResolver(keyframes, function (resolvedKeyframes, finalKeyframe) {
      return _this.onKeyframesResolved(resolvedKeyframes, finalKeyframe);
    }, name, motionValue, element);
    _this.resolver.scheduleResolve();
    return _this;
  }
  _inherits(AcceleratedAnimation, _BaseAnimation);
  return _createClass(AcceleratedAnimation, [{
    key: "initPlayback",
    value: function initPlayback(keyframes, finalKeyframe) {
      var _this2 = this;
      var _a;
      var _this$options2 = this.options,
        _this$options2$durati = _this$options2.duration,
        duration = _this$options2$durati === void 0 ? 300 : _this$options2$durati,
        times = _this$options2.times,
        ease = _this$options2.ease,
        type = _this$options2.type,
        motionValue = _this$options2.motionValue,
        name = _this$options2.name,
        startTime = _this$options2.startTime;
      /**
       * If element has since been unmounted, return false to indicate
       * the animation failed to initialised.
       */
      if (!((_a = motionValue.owner) === null || _a === void 0 ? void 0 : _a.current)) {
        return false;
      }
      /**
       * If this animation needs pre-generated keyframes then generate.
       */
      if (requiresPregeneratedKeyframes(this.options)) {
        var _this$options3 = this.options,
          onComplete = _this$options3.onComplete,
          onUpdate = _this$options3.onUpdate,
          _motionValue = _this$options3.motionValue,
          element = _this$options3.element,
          options = _objectWithoutProperties(_this$options3, _excluded);
        var pregeneratedAnimation = pregenerateKeyframes(keyframes, options);
        keyframes = pregeneratedAnimation.keyframes;
        // If this is a very short animation, ensure we have
        // at least two keyframes to animate between as older browsers
        // can't animate between a single keyframe.
        if (keyframes.length === 1) {
          keyframes[1] = keyframes[0];
        }
        duration = pregeneratedAnimation.duration;
        times = pregeneratedAnimation.times;
        ease = pregeneratedAnimation.ease;
        type = "keyframes";
      }
      var animation = animateStyle(motionValue.owner.current, name, keyframes, _objectSpread(_objectSpread({}, this.options), {}, {
        duration: duration,
        times: times,
        ease: ease
      }));
      // Override the browser calculated startTime with one synchronised to other JS
      // and WAAPI animations starting this event loop.
      animation.startTime = startTime !== null && startTime !== void 0 ? startTime : this.calcStartTime();
      if (this.pendingTimeline) {
        animation.timeline = this.pendingTimeline;
        this.pendingTimeline = undefined;
      } else {
        /**
         * Prefer the `onfinish` prop as it's more widely supported than
         * the `finished` promise.
         *
         * Here, we synchronously set the provided MotionValue to the end
         * keyframe. If we didn't, when the WAAPI animation is finished it would
         * be removed from the element which would then revert to its old styles.
         */
        animation.onfinish = function () {
          var onComplete = _this2.options.onComplete;
          motionValue.set(getFinalKeyframe(keyframes, _this2.options, finalKeyframe));
          onComplete && onComplete();
          _this2.cancel();
          _this2.resolveFinishedPromise();
        };
      }
      return {
        animation: animation,
        duration: duration,
        times: times,
        type: type,
        ease: ease,
        keyframes: keyframes
      };
    }
  }, {
    key: "duration",
    get: function get() {
      var resolved = this.resolved;
      if (!resolved) return 0;
      var duration = resolved.duration;
      return millisecondsToSeconds(duration);
    }
  }, {
    key: "time",
    get: function get() {
      var resolved = this.resolved;
      if (!resolved) return 0;
      var animation = resolved.animation;
      return millisecondsToSeconds(animation.currentTime || 0);
    },
    set: function set(newTime) {
      var resolved = this.resolved;
      if (!resolved) return;
      var animation = resolved.animation;
      animation.currentTime = secondsToMilliseconds(newTime);
    }
  }, {
    key: "speed",
    get: function get() {
      var resolved = this.resolved;
      if (!resolved) return 1;
      var animation = resolved.animation;
      return animation.playbackRate;
    },
    set: function set(newSpeed) {
      var resolved = this.resolved;
      if (!resolved) return;
      var animation = resolved.animation;
      animation.playbackRate = newSpeed;
    }
  }, {
    key: "state",
    get: function get() {
      var resolved = this.resolved;
      if (!resolved) return "idle";
      var animation = resolved.animation;
      return animation.playState;
    }
  }, {
    key: "startTime",
    get: function get() {
      var resolved = this.resolved;
      if (!resolved) return null;
      var animation = resolved.animation;
      // Coerce to number as TypeScript incorrectly types this
      // as CSSNumberish
      return animation.startTime;
    }
    /**
     * Replace the default DocumentTimeline with another AnimationTimeline.
     * Currently used for scroll animations.
     */
  }, {
    key: "attachTimeline",
    value: function attachTimeline(timeline) {
      if (!this._resolved) {
        this.pendingTimeline = timeline;
      } else {
        var resolved = this.resolved;
        if (!resolved) return noop;
        var animation = resolved.animation;
        animation.timeline = timeline;
        animation.onfinish = null;
      }
      return noop;
    }
  }, {
    key: "play",
    value: function play() {
      if (this.isStopped) return;
      var resolved = this.resolved;
      if (!resolved) return;
      var animation = resolved.animation;
      if (animation.playState === "finished") {
        this.updateFinishedPromise();
      }
      animation.play();
    }
  }, {
    key: "pause",
    value: function pause() {
      var resolved = this.resolved;
      if (!resolved) return;
      var animation = resolved.animation;
      animation.pause();
    }
  }, {
    key: "stop",
    value: function stop() {
      this.resolver.cancel();
      this.isStopped = true;
      if (this.state === "idle") return;
      this.resolveFinishedPromise();
      this.updateFinishedPromise();
      var resolved = this.resolved;
      if (!resolved) return;
      var animation = resolved.animation,
        keyframes = resolved.keyframes,
        duration = resolved.duration,
        type = resolved.type,
        ease = resolved.ease,
        times = resolved.times;
      if (animation.playState === "idle" || animation.playState === "finished") {
        return;
      }
      /**
       * WAAPI doesn't natively have any interruption capabilities.
       *
       * Rather than read commited styles back out of the DOM, we can
       * create a renderless JS animation and sample it twice to calculate
       * its current value, "previous" value, and therefore allow
       * Motion to calculate velocity for any subsequent animation.
       */
      if (this.time) {
        var _this$options4 = this.options,
          motionValue = _this$options4.motionValue,
          onUpdate = _this$options4.onUpdate,
          onComplete = _this$options4.onComplete,
          element = _this$options4.element,
          options = _objectWithoutProperties(_this$options4, _excluded2);
        var sampleAnimation = new MainThreadAnimation(_objectSpread(_objectSpread({}, options), {}, {
          keyframes: keyframes,
          duration: duration,
          type: type,
          ease: ease,
          times: times,
          isGenerator: true
        }));
        var sampleTime = secondsToMilliseconds(this.time);
        motionValue.setWithVelocity(sampleAnimation.sample(sampleTime - sampleDelta).value, sampleAnimation.sample(sampleTime).value, sampleDelta);
      }
      var onStop = this.options.onStop;
      onStop && onStop();
      this.cancel();
    }
  }, {
    key: "complete",
    value: function complete() {
      var resolved = this.resolved;
      if (!resolved) return;
      resolved.animation.finish();
    }
  }, {
    key: "cancel",
    value: function cancel() {
      var resolved = this.resolved;
      if (!resolved) return;
      resolved.animation.cancel();
    }
  }], [{
    key: "supports",
    value: function supports(options) {
      var motionValue = options.motionValue,
        name = options.name,
        repeatDelay = options.repeatDelay,
        repeatType = options.repeatType,
        damping = options.damping,
        type = options.type;
      return supportsWaapi() && name && acceleratedValues.has(name) && motionValue && motionValue.owner && motionValue.owner.current instanceof HTMLElement &&
      /**
       * If we're outputting values to onUpdate then we can't use WAAPI as there's
       * no way to read the value from WAAPI every frame.
       */
      !motionValue.owner.getProps().onUpdate && !repeatDelay && repeatType !== "mirror" && damping !== 0 && type !== "inertia";
    }
  }]);
}(BaseAnimation);
export { AcceleratedAnimation };